import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Contact } from '../views/presentation-dynamic-view/dynamic-contacts/dynamic-contacts.model';
import { CustomDataRetriever } from './custom-data-retriever.abstract';

@Injectable()
export class ReportContactsService extends CustomDataRetriever {
  constructor(private http: HttpClient) {
    super();
  }

  getCustomData(reportId: number): Observable<Partial<Contact>[]> {
    const uri = `/api/reports/${reportId}/contacts`;
    return this.cachedCustomData(uri, this.http.get.bind(this.http, uri)).pipe(
      map((reportContacts: Contact[]) =>
        reportContacts.map(
          ({ id: _id, checked: _checked, nameType: _nameType, phoneType: _phoneType, ...reportContacts }) =>
            reportContacts
        )
      )
    );
  }
}
